import { useMemo } from "react";
import { commercePaths, fashionPaths, type CommercePaths } from "../paths";
import { useActiveModule } from "./use-active-module";

/**
 * Commerce bileşenleri için aktif instance'a bağlı path seti.
 *
 * `/technology/shop`'ta render edilen bir ürün kartı `/technology/product/:id`
 * üretir; `/fashion/shop`'ta `/fashion/product/:id`. Modül dışında (örn. cart
 * sayfasında açılan ProductDetailModal) fashion'a düşer — bugünkü davranış.
 */
export const useCommercePaths = (): CommercePaths => {
  const active = useActiveModule();
  return useMemo(
    () =>
      active?.blueprint === "commerce" ? commercePaths(active) : fashionPaths,
    [active],
  );
};
